<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="animated fadeIn">
          <b-row>
            <b-col md="12">
              <b-modal
                v-model="show"
                title="Confirmation"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
                :footer-bg-variant="footerBgVariant"
                :footer-text-variant="footerTextVariant"
                id="modal_box"
                size="md"
              >
                <b-container fluid>
                  <vue-snotify></vue-snotify>
                  <ValidationObserver
                    ref="form"
                    v-slot="{ passes }"
                    
                  >
                    <b-form
                      action="#"
                      @submit.prevent="passes(submitStatusUpdateUser)"
                      v-if="activate_type == 0"
                    >
                      <ValidationProvider
                        vid="remark"
                        name="Reason"
                        v-slot="{ errors }"
                        rules="required|min:10"
                      >
                        <b-row class="row-top">
                          <b-col cols="12">
                            <b-form-textarea
                              id="reason"
                              v-model="remark"
                              placeholder="Reason"
                              rows="3"
                              max-rows="6"
                            ></b-form-textarea>
                            <br />
                            <div v-if="errors[0]" class="error_txt">
                              <p
                                v-for="(error, index) in errors"
                                v-bind:key="index"
                              >
                                {{ error }}
                              </p>
                            </div>
                          </b-col>
                        </b-row>
                      </ValidationProvider>

                      <b-row class="row-top row-bottom">
                        <b-col cols="12">
                          <b-row>
                            <b-col cols="6">
                              <b-button block type="submit" variant="primary"
                                >Deactivate</b-button
                              >
                            </b-col>
                            <b-col cols="6">
                              <b-button v-on:click="closeModal()" block
                                >Cancel</b-button
                              >
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col cols="4">
                          <div></div>
                        </b-col>
                      </b-row>
                    </b-form>
                  </ValidationObserver>
                  <div v-if="activate_type == 1">
                    <b-row>
                      <b-col cols="12">
                        <p>Are you sure you want to Activate this Account?</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <b-button
                          block
                          type="submit"
                          variant="primary"
                          v-on:click="submitStatusUpdateUser()"
                          >Activate</b-button
                        >
                      </b-col>
                      <b-col cols="6">
                        <b-button v-on:click="closeModal()" block
                          >Cancel</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                </b-container>
              </b-modal>


              <div class="table-responsive">
              <Vuetable
                class="table table-striped table-bordered nowrap vue-tbl"
                ref="Vuetable"
                :api-url="getUrl"
                :http-options="httpOptions"
                :fields="fields"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
                :append-params="moreParams"
                :per-page="perPage"
              >
                <template slot="actions" scope="props">
                  <div class="custom-actions">
                    <b-button
                      v-if="$can('View_user', 'all')"
                      class="btn btn-success btn-sm"
                      @click="
                        onActionClicked(
                          'view-item',
                          props.rowData,
                          props.rowIndex
                        )
                      "
                    >
                      <i class="cui-user-follow"></i> View
                    </b-button>

                    <b-button
                      v-if="$can('Edit_user', 'all')"
                      class="btn btn-warning btn-sm"
                      @click="
                        onActionClicked(
                          'edit-item',
                          props.rowData,
                          props.rowIndex,
                          true
                        )
                      "
                    >
                      <i class="cui-user-follow"></i>Edit
                    </b-button>

                    <b-button
                      v-if="$can('Reset_Password_Other', 'all')"
                      class="btn btn-info btn-sm"
                      @click="
                        onActionClicked(
                          'reset-password',
                          props.rowData,
                          props.rowIndex,
                          true
                        )
                      "
                    >
                      <i class="cui-user-follow"></i>Reset Password
                    </b-button>

                    <b-button
                      v-if="
                        props.rowData.active == 1 &&
                          $can('Deactivate_User', 'all')
                      "
                      class="btn btn-danger btn-sm"
                      @click="
                        onActionClicked(
                          'deactivate',
                          props.rowData,
                          props.rowIndex
                        )
                      "
                    >
                      <i class="cui-user-follow"></i> Deactivate
                    </b-button>
                    <b-button
                      v-else
                      class="btn btn-inverse btn-sm"
                      @click="
                        onActionClicked(
                          'activate',
                          props.rowData,
                          props.rowIndex
                        )
                      "
                    >
                      <i class="cui-user-follow"></i> Activate
                    </b-button>
                  </div>
                </template>
              </Vuetable>

              <b-row>
                <b-col>
                   <div class="vuetable-pagination ui basic segment grid row">
                    <b-col cols="4">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                      ></vuetable-pagination-info>
                    </b-col>
                    <b-col cols="8">
                      <vuetable-pagination
                        style="float:right;"
                        ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </b-col>
                  </div>
                </b-col>
              </b-row>
              </div>


              <vue-snotify></vue-snotify>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetablePagination from "@/components/vuetable/VuetablePaginationBootstrap4";
import { mapState, mapActions } from "vuex";
export default {
  name: "Usertable",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data() {
    return {
      activate_title: "",
      activate_type: "",
      user_id: "",
      remark: "",
      variants: [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "light",
        "dark"
      ],
      headerBgVariant: "dark",
      headerTextVariant: "light",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
      show: false,

      httpOptions: {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        },
        data: {}
      },
      moreParams: {},
      getUrl: process.env.VUE_APP_API_ENDPOINT + "users",
      fields: [
        {
          name: "id",
          title: '<span class="orange glyphicon glyphicon-user"></span> #',
          sortField: "id"
        },
        {
          name: "user_name",
          title:
            '<span class="orange glyphicon glyphicon-user"></span> Username',
          sortField: "user_name"
        },
        {
          name: "full_name",
          title: '<span class="orange glyphicon glyphicon-user"></span> Name',
          sortField: "first_name"
        },
        {
          name: "email",
          title: '<span class="orange glyphicon glyphicon-user"></span> Email',
          sortField: "email"
        },
        {
          name: "agent_code",
          title:
                  '<span class="orange glyphicon glyphicon-user"></span> Agent Code',
          sortField: "agent_code"
        },
        {
          name: "roles",
          title:
            '<span class="orange glyphicon glyphicon-user"></span> User Role',
          sortField: "first_name",
          callback: "getRoles",
          html: true
        },
        {
          name: "active",
          title: '<span class="orange glyphicon glyphicon-user"></span> Status',
          sortField: "active",
          callback: "activeStatus",
          html: true
        },
        
        {
          name: "updated_at",
          title:
            '<span class="orange glyphicon glyphicon-user"></span> Last Updated',
          sortField: "updated_at"
        },
        {
          name: "__slot:actions",
          title: '<span class="orange glyphicon glyphicon-user"></span> Action'
        }
      ],
      data: [],
      perPage: 10,
      sortOrder: [],
      filterText: ""
    };
  },
  computed: {
    ...mapState("user", ["errors"])
  },
  methods: {
    ...mapActions("user", ["updateUserStatus"]),
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.Vuetable.changePage(page);
    },
    onFilterSet(filters) {
      this.moreParams = {
        full_name: filters.full_name,
        user_name: filters.user_name,
        user_role: filters.user_role,
        company: filters.company,
        email: filters.email,
        active: filters.status
      };
      Vue.nextTick(() => this.$refs.Vuetable.refresh());
    },
    onFilterReset() {
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.Vuetable.refresh());
    },
    getFullName(roles) {
      let str = "";
      roles.forEach(function(role, index) {
        str += role.name;
        if (index != roles.length - 1) {
          str += ",";
        }
      });
      return str;
    },
    getRoles(roles) {
      let str = "";
      roles.forEach(function(role, index) {
        str +=  role.name;
        if (index != roles.length - 1) {
          str += ",";
        }
      });
      return str;
    },
    onActionClicked(action, data, rowIndex, pdf = false) {
      if (action == "edit-item") {
        this.$router.push({
          name: "UserEdit",
          params: {
            user_id: data.id
          }
        });
      } else if (action == "view-item") {
        this.$router.push({
          name: "User",
          params: {
            id: data.id
          }
        });
      } else if (action == "reset-password") {
        this.$router.push({
          name: "ResetPassword",
          params: {
            user_id: data.id
          }
        });
      } else if (action == "activate") {
        this.activate_title = "Activate";
        this.activate_type = 1;
        this.user_id = data.id;
        this.$bvModal.show("modal_box");
      } else if (action == "deactivate") {
        this.activate_title = "Deactivate";
        this.activate_type = 0;
        this.user_id = data.id;
        this.remark = "";
        this.$bvModal.show("modal_box");
      }
    },
    async submitStatusUpdateUser() {
      const userInfo = {
        user_id: this.user_id,
        remark: this.activate_type == 0 ? this.remark : "",
        status: this.activate_type
      };

      await this.updateUserStatus(userInfo).then(response => {
        this.$snotify.clear();
        if (response.data.success) {
          this.$refs.form.reset();
          this.$snotify
            .success(response.data.success.message, "", {
              position: "centerTop"
            })
            .on("destroyed", () =>
              this.$refs.Vuetable.refresh().then(this.resetForm())
            );
        } else {
          this.$snotify.error(response.data.error.message, "Error!", {
            position: "centerTop"
          });
        }
      });
      if (this.activate_type == 0) {
        this.$refs.form.setErrors(this.errors);
      }
    },
    closeModal() {
      this.$bvModal.hide("modal_box");
    },
    resetForm() {
      this.user_id = "";
      this.show = false;
      this.remark = "";
      this.activate_type = "";
    },
    activeStatus(val) {
      return val
        ? "<span class='badge badge-success'>Active</span>"
        : "<span class='badge badge-danger'>Inactive</span>";
    }
  },
  watch: {
    data(newVal, oldVal) {
      this.$refs.Vuetable.refresh();
    }
  },

  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.error_txt {
  color: red;
  font-style: italic;
  font-size: 11px;
}

.custom-actions .btn {
  margin-right: 5px;
  margin-bottom: 3px;
}

.custom-actions{
    min-width: 370px;
}
</style>
